module.exports = __webpack_public_path__ + "static/Anbaugebiet-Franken-600x388-7d19587f598012c295ea893cd6f4ac28.jpeg";